/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { DoubleSide } from 'three';
let ShapeRectangle = class ShapeRectangle extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const geometryRectangle = Solids.createRectangle(1, 1);
        geometryRectangle.scale(shape.width, shape.height, 1);
        geometryRectangle.rotateZ(shape.orientationRad);
        geometryRectangle.translate(shape.cx, shape.cy, 0);
        this.geometry = geometryRectangle;
        this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide, depthWrite: false });
        this.addOutline(this.geometry, decoration);
    }
    format() {
        return undefined;
    }
};
ShapeRectangle = tslib_1.__decorate([
    Shape('Shape.Rectangle'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], ShapeRectangle);
export { ShapeRectangle };
//# sourceMappingURL=ShapeRectangle.js.map